export default __webpack_public_path__ + "static/media/arrow.57b6e8b3.svg";